import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import { TCountryDeclensionsParams } from '../../types/analytics-notes';
import { ANALYTICS_NOTES_COMMON_ACTIONS_NAME, ANALYTICS_NOTES_COMMON_MUTATIONS_NAME } from './name';
import { TAnalyticsNotesCommonState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function searchCountryDeclensions(
  context: ActionContext<TAnalyticsNotesCommonState, unknown>,
  params: TCountryDeclensionsParams,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.common.getCountryDeclensions,
      name: getLocalState(ANALYTICS_NOTES_COMMON_ACTIONS_NAME.searchCountryDeclensions),
      mutate: getLocalState(ANALYTICS_NOTES_COMMON_MUTATIONS_NAME.setCountryDeclensions),
    },
    params,
  );
}
